import { useEffect, useState } from "react";
import { FaHeart, FaMapMarkerAlt } from "react-icons/fa";
import Hero from "../components/Hero";
import heroImg from "../assests/images/hero.jpg";
import { useNavigate } from "react-router-dom";


export default function Wishlist() {
    const [wishlist, setWishlist] = useState([]);
    const navigate = useNavigate();

    const removeFromWishlist = (id) => {
        const updated = wishlist.filter(item => item.id !== id);
        setWishlist(updated);
        localStorage.setItem("wishlist", JSON.stringify(updated));
    };

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem("wishlist")) || [];
        setWishlist(stored);
    }, []);

    return (
        <div>
            <Hero
                heightClass="h-[180px] sm:h-[230px] md:h-[250px] lg:h-[200px]"
                title="Wishlist"
                backgroundImage={heroImg}
                contentClass=""
            />

            <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">

                <h2 className="text-2xl sm:text-3xl font-bold text-[#0F172A] mb-6 sm:mb-8 flex items-center gap-2">
                    My Wishlist
                    <svg
                        className="bg-pink-50 text-pink-600 w-7 h-7"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                        />
                    </svg>
                </h2>

                {wishlist.length === 0 ? (
                    <div className="flex flex-col items-center justify-center py-20 text-center">
                        <div className="w-16 h-16 rounded-2xl bg-[#F8F5EC] flex items-center justify-center mb-4">
                            <FaHeart className="text-2xl text-[#D4A83F]" />
                        </div>

                        <h3 className="text-lg font-bold text-slate-900">
                            Your Wishlist is Empty
                        </h3>

                        <p className="text-gray-500 text-sm sm:text-base mt-1">
                            Save your favorite hotels here for easy access later.
                        </p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mt-12">

                        {wishlist.map((hotel) => (
                            <div
                                key={hotel.id}
                                onClick={() => navigate(`/hotels/${hotel.slug}`)}
                                className="
                    group
                    cursor-pointer
                    bg-white
                    rounded-[28px]
                    overflow-hidden
                    border border-slate-100
                    shadow-lg
                    hover:shadow-[0_20px_50px_rgba(15,23,42,0.14)]
                    hover:-translate-y-2
                    transition-all
                    duration-500
                "
                            >

                                {/* ================= IMAGE ================= */}
                                <div className="relative h-52 sm:h-56 md:h-60 w-full overflow-hidden">

                                    <img
                                        src={`https://jumeiradiscounthotels.com/uploads/hotels/${hotel.image}`}
                                        alt={hotel.name}
                                        className="
                            w-full
                            h-full
                            object-cover
                            group-hover:scale-110
                            transition-transform
                            duration-700
                        "
                                    />

                                    {/* Dark Gradient */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>


                                    {/* ================= LOCATION ================= */}
                                    <div className="absolute top-4 left-4 z-20">
                                        <span className="
                            inline-flex
                            items-center
                            gap-1.5
                            bg-white/95
                            backdrop-blur-md
                            text-slate-700
                            px-3
                            py-1.5
                            rounded-full
                            text-xs
                            font-semibold
                            shadow-lg
                        ">
                                            <FaMapMarkerAlt className="text-[#174B5F]" />
                                            {hotel.location || "Dubai, UAE"}
                                        </span>
                                    </div>


                                    {/* ================= WISHLIST ================= */}
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            removeFromWishlist(hotel.id);
                                        }}
                                        className="
                            absolute
                            top-4
                            right-4
                            z-20
                            w-10
                            h-10
                            rounded-full
                            bg-white/95
                            backdrop-blur-md
                            shadow-lg
                            flex
                            items-center
                            justify-center
                            hover:bg-red-50
                            hover:scale-110
                            transition-all
                            duration-300
                        "
                                        aria-label="Remove from wishlist"
                                    >
                                        <FaHeart className="text-red-500 text-sm" />
                                    </button>


                                    {/* ================= RATING ================= */}
                                    <div className="
                        absolute
                        bottom-4
                        left-4
                        z-20
                        flex
                        items-center
                        gap-2
                    ">

                                        <div className="
                            flex
                            items-center
                            gap-1
                            bg-white/95
                            backdrop-blur-md
                            px-3
                            py-1.5
                            rounded-xl
                            shadow-lg
                        ">
                                            <span className="text-yellow-500 text-sm">
                                                ★
                                            </span>

                                            <span className="text-slate-900 text-sm font-bold">
                                                {hotel.rating || "4.5"}
                                            </span>

                                            <span className="text-slate-400 text-xs">
                                                Excellent
                                            </span>
                                        </div>

                                    </div>


                                    {/* ================= PRICE ================= */}
                                    <div className="
                        absolute
                        bottom-4
                        right-4
                        z-20
                        bg-gradient-to-r
                        from-[#002B45]
                        via-[#174B5F]
                        to-[#D4A83F]
                        text-white
                        px-4
                        py-2
                        rounded-2xl
                        shadow-xl
                    ">
                                        <p className="text-[9px] uppercase tracking-wider opacity-80">
                                            From
                                        </p>

                                        <p className="text-sm font-bold">
                                            AED {Math.round(hotel.price_per_night)}
                                            <span className="text-[10px] font-normal opacity-80">
                                                {" "} / night
                                            </span>
                                        </p>
                                    </div>

                                </div>


                                {/* ================= CONTENT ================= */}
                                <div className="p-5 sm:p-6">

                                    {/* Hotel Name */}
                                    <h3 className="
                        text-lg
                        sm:text-xl
                        font-bold
                        text-slate-900
                        line-clamp-1
                        group-hover:text-[#174B5F]
                        transition-colors
                        duration-300
                    ">
                                        {hotel.name}
                                    </h3>


                                    {/* Location */}
                                    <div className="flex items-center gap-2 mt-2 text-slate-500">

                                        <FaMapMarkerAlt className="text-[#D4A83F] text-sm" />

                                        <span className="text-sm">
                                            {hotel.location || "Dubai, UAE"}
                                        </span>

                                    </div>


                                    {/* Divider */}
                                    <div className="h-px bg-slate-100 my-4"></div>


                                    {/* Description */}
                                    <p className="
                        text-slate-600
                        text-sm
                        leading-6
                        line-clamp-2
                        min-h-[48px]
                    ">
                                        {hotel.short_description?.replace(/<[^>]*>/g, "")}
                                    </p>


                                    {/* Amenities */}
                                    <div className="
                        flex
                        flex-wrap
                        gap-2
                        mt-4
                    ">

                                        <span className="
                            px-2.5
                            py-1
                            rounded-full
                            bg-[#F8F5EC]
                            text-[#174B5F]
                            text-[11px]
                            font-medium
                        ">
                                            🏊 Pool
                                        </span>

                                        <span className="
                            px-2.5
                            py-1
                            rounded-full
                            bg-[#F8F5EC]
                            text-[#174B5F]
                            text-[11px]
                            font-medium
                        ">
                                            📶 WiFi
                                        </span>

                                        <span className="
                            px-2.5
                            py-1
                            rounded-full
                            bg-[#F8F5EC]
                            text-[#174B5F]
                            text-[11px]
                            font-medium
                        ">
                                            🍽 Restaurant
                                        </span>

                                    </div>


                                    {/* ================= FOOTER ================= */}
                                    <div className="mt-5">

                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(`/hotels/${hotel.slug}`);
                                            }}
                                            className="
                                w-full
                                py-3
                                rounded-xl
                                bg-gradient-to-r
                                from-[#002B45]
                                via-[#174B5F]
                                to-[#D4A83F]
                                text-white
                                text-sm
                                font-semibold
                                shadow-md
                                hover:shadow-xl
                                hover:-translate-y-0.5
                                transition-all
                                duration-300
                            "
                                        >
                                            View Hotel Details
                                            <span className="ml-2">
                                                →
                                            </span>
                                        </button>

                                    </div>

                                </div>

                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}